const helpers = {};

// returns the spelled out month in english
helpers.month = () => new Date().toLocaleString('en', { month: 'long' });

// returns the spelled out month in english
helpers.year = () => new Date().getFullYear();


export default helpers;
